import * as styles from "./MainInformations.css";

import type { JSX } from "react";

import { Separator } from "@frontend/components/atoms/Separator";

import { GeneralSection } from "./GeneralSection";
import { Interlocutors } from "./Interlocutors";
import { LocationSection } from "./LocationSection";

export function MainInformations(): JSX.Element {
  return (
    <div className={styles.tab}>
      <div className={styles.columns}>
        <div className={styles.column}>
          <GeneralSection />

          <LocationSection />
        </div>

        <Separator orientation="vertical" className={styles.separator} />

        <div className={styles.column}>
          <Interlocutors />
        </div>
      </div>
    </div>
  );
}
